import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const API_URL = '/cargo/api/certificate-document-types';

export interface CertificateDocumentType {
  id: number;
  name: string;
  hint?: string;
  active: boolean;
  viewOrder: number;
}

export interface CreateCertificateDocumentTypeRequest {
  name: string;
  hint?: string;
  active?: boolean;
  viewOrder?: number;
}

export interface UpdateCertificateDocumentTypeRequest {
  name: string;
  hint?: string;
  active?: boolean;
  viewOrder?: number;
}

@Injectable({
  providedIn: 'root'
})
export class CertificateDocumentTypesService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<CertificateDocumentType[]> {
    return this.http.get<CertificateDocumentType[]>(API_URL);
  }

  create(request: CreateCertificateDocumentTypeRequest): Observable<CertificateDocumentType> {
    return this.http.post<CertificateDocumentType>(API_URL, request);
  }

  update(id: number, request: UpdateCertificateDocumentTypeRequest): Observable<CertificateDocumentType> {
    return this.http.put<CertificateDocumentType>(`${API_URL}/${id}`, request);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${API_URL}/${id}`);
  }
}
